import { socket } from "@/shared/config/socket";
import { useEffect, useState } from "react";

interface IData {
  setLoad: any;
  load: boolean;
  ky: any;
  setShowModalDatCuoc?: any;
  showModalDatCuoc?: any;
  gameId: number;
}
const KyQuay = (props: IData) => {
  const { setLoad, load, ky, gameId } = props;
  const [timeString, setTimeString] = useState<any>("00:00");
  useEffect(() => {
    socket.on("drawUpdate", (data) => {
      const game = data?.[gameId];
      if (Number(ky?.id) !== Number(game?.id)) {
        setLoad(!load);
        return;
      }
      const second = game?.second;
      if (!second) {
        setTimeString("00:00");
        return;
      }
      const minutes = Math.floor(second / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (second % 60).toString().padStart(2, "0");
      setTimeString(`${minutes}:${seconds}`);
    });
    return () => {
      socket.off("drawUpdate");
    };
  }, [gameId, ky]);

  return (
    <div
      className="px-2 py-0 rounded-1"
      style={{
        fontFamily: "Digital",
        border: "2px solid rgb(255, 0, 0)",
        fontSize: 25,
        color: "rgb(255, 0, 0)",
        width: 110,
        letterSpacing: 5,
      }}
    >
      {timeString}
    </div>
  );
};

export default KyQuay;
